import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import { withRouter } from "react-router-dom";
import * as fuiRedux from "../../redux/fui/index";
import { tokenValidation } from "../../helper/customizedHooks";
import PropTypes from "prop-types";
import { AcceptButton2, SecondaryButton } from '../common/CommonComponents/Buttons';
import { CommonDialog, CommonDialogV2 } from "../common/CommonComponents/Dialog";
import {
    AcceptButton,
    DeclineButton,
} from "../common/CommonComponents/Buttons";
import { DialogActions, Button, FormLabel, Menu } from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from "@material-ui/core";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 370,
        height: 280,
        border: "1px solid #888888",
        borderRadius: "5px",
        boxShadow: "unset",
        padding: "0px 10px 10px 0px",
        color: "black",
        transistion: '300ms ease-in-out',
        "&:hover": {
            backgroundColor: '#F5F5F5'
        },
        position: "relative",
        overflow: "hidden"
    },
    action: {
        fontSize: "x-small",
        backgroundColor: "#7500C0",
        color: "#FFF",
        padding: "0.5em 1em",
        borderRadius: "40px"
    },
    subheader: {
        marginTop: "1%",
        paddingLeft: "1%",
        marginBottom: "0%",
        color: "black",
        textWrap: "nowrap"
    },
    viewButton: {
        border: "1px solid #888888",
        color: "#a100ff",
        borderRadius: "0px",
        float: "right",
        position: "absolute",       /* Positioned relative to .container */
        bottom: "15px",           /* Distance from bottom */
        right: "15px",
    },
    viewButtonLeft: {
        borderColor: "transparent",
        color: "#a100ff",
        borderRadius: "0px",
        float: "left"
    },
    instanceTypeButton: {
        fontWeight: "500",
        color: "#a100ff",
        fontSize: "14px",
        paddingLeft: "8px",
    },
    versionButton: {
        color: "#333",
        fontSize: ".85em",
        paddingLeft: "8px",
    },
    menuOptions: {
        fontSize: "14px",
    },
    versionOptions: {
        fontSize: ".85em",
    },
    header: {
        fontWeight: 600
    },
    cardActions: {
        display: "block",
        padding: "10px 2px 10px 10px"
    }
}));


const ProductCard = ({ history, resetFuiState, product }) => {
    useEffect(() => {
        tokenValidation();
        resetFuiState();
    }, []);
    const classes = useStyles();
    const [openSplunkClusterWarningDialog, setOpenSplunkClusterWarningDialog] = useState(false);
    const [openGADialog, setOpenGADialog] = useState(false);
    const [instanceType, setInstanceType] = useState("Container");
    const [gaDisable, setGaDisable] = useState(false);
    const [camEnvironment, setCAMEnvironment] = useState("");
    const [stateVersion, setStateversion] = useState("");
    const [coreVersion, setCoreversion] = useState("");
    const handleSplunkClusterWarningSubmit = (ProductsInfomation) => {
        //alert(ProductsInfomation)
        history.push(`/fui/order/splunkClusterPlatform`)
        // setOpenSplunkClusterWarningDialog(false);
    };

    const version = (args, appName) => {
        const raw = process.env.REACT_APP_CAMENVPORTAL !== 'production'
            ? product.versionUat
            : product.versionProd;

        if (!raw) {
            setStateversion("");
            return;
        }

        try {
            const versionname = JSON.parse(raw);
            if (typeof versionname !== "object" || versionname === null) {
                // Parsed to a primitive (e.g. a bare number) — treat as plain version string
                setStateversion(String(versionname));
                return;
            }
            const key = args.toLowerCase();
            let matched = versionname[args];
            if (matched === undefined || matched === null) {
                matched = versionname[key];
            }
            if (matched === undefined || matched === null) {
                matched = "";
            }
            setStateversion(matched);
        } catch (e) {
            // SI stores a plain version string like "1.7.1", not a per-type JSON map.
            // Use it as-is regardless of instance type (Dedicated/Integration).
            setStateversion(raw);
        }
    };

    const handleChangeVersion = (event, productItem) => {
        const stable = JSON.parse(productItem.appCoreVersionStable);
        const test = JSON.parse(productItem.appCoreVersionTest);
        const selectedValue = event.target.value;
        if (selectedValue) {
            if (selectedValue.indexOf('GA-') >= 0) {
                const splitValue = selectedValue.split("-");
                setStateversion(splitValue[1]);
                if (splitValue[2] === "v1") {
                    setCoreversion(stable);
                    setGaDisable(false);
                } else {
                    setOpenGADialog(true);
                    setGaDisable(true)
                    setCoreversion(test);
                }
            }

        }
        setInstanceType(selectedValue);
    };
    const handleChangeInstanceType = (event) => {
        const selectedValue = event.target.value;
        if (selectedValue) {
            version(selectedValue);
        }
        setInstanceType(selectedValue);
    };

    return (
        <div>
            <Card className={classes.root}>
                <CardHeader
                    // action={
                    //   <p className={classes.action}>DEDICATED</p>
                    // }
                    classes={{
                        title: classes.header
                    }}
                    title={product.productName}
                    subheader={
                        <p className={classes.subheader}>
                            {/* Version -  {product.productName === "Auto Resolver" ? */}
                            Version -  {product.productName === "" ?
                                stateVersion
                                :
                                <>
                                    {
                                        process.env.REACT_APP_CAMENVPORTAL !== 'production' ?
                                            <span> {product.versionUat}</span>
                                            :
                                            <span> {product.versionProd}</span>
                                    }
                                </>
                            }
                        </p>
                    }
                />
                <CardContent>
                    <Typography variant="body1" color="textPrimary" component="p" >
                        {product.productDescription.substring(0, 135).trimEnd() + '...'}
                    </Typography>
                </CardContent>
                <CardActions className={classes.cardActions}>
                    {/* {(product.productName === "Service Integrator" || product.productName === "Auto Resolver") ? */}
                    {(product.productName === "Service Integrator") ?
                        <FormControl variant="outlined" className={classes.formControl} style={{ marginTop: '10px' }}>
                            <TextField
                                id="select"
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    className: classes.instanceTypeButton
                                }}
                                value={instanceType}
                                onChange={handleChangeInstanceType}
                                select>
                                <MenuItem className={classes.menuOptions} value=" " disabled selected>Type</MenuItem>
                                <MenuItem className={classes.menuOptions} value="Dedicated">DEDICATED</MenuItem>
                                {product.productName === "Service Integrator" &&
                                    <MenuItem className={classes.menuOptions} value="Integration">INTEGRATION</MenuItem>
                                }
                                {product.productName === "Auto Resolver" &&
                                    <MenuItem className={classes.menuOptions} value="Container">CONTAINER</MenuItem>
                                }
                            </TextField>
                        </FormControl>
                        :
                        (product.productName === "Genwizard Agent" || product.productName === "Knowledge Manager" || product.productName === "Knowledge Transition" || product.productName === "Auto Resolver") ?
                            <FormControl variant="outlined" className={classes.formControl} style={{ margin: '20px 0 0 10px' }}>
                                <FormLabel style={{ color: '#7500C0' }}>Container</FormLabel>
                            </FormControl>
                            :
                            ""
                    }
                    {
                        product.status === "enable" ?
                            <SecondaryButton
                                disabled={((product.productName === "Service Integrator") && instanceType === " ") || gaDisable === true ? true : false}
                                // disabled={(product.productName === "Service Integrator" || product.productName === "Auto Resolver" || product.productName === "Genwizard Agent") && instanceType === " " ? true : false}
                                placeholder="test"
                                label={"Create"}
                                className={classes.viewButton}
                                onClick={() =>
                                    product.routeName === 'splunkClusterPlatform'
                                        ? setOpenSplunkClusterWarningDialog(true)
                                        : product.productName === 'Genwizard Agent'
                                            ? history.push({
                                                pathname: `/fui/order/${product.routeName}`,
                                                state: {
                                                    InstanceType: instanceType,
                                                    CAMPortalEnvironment: process.env.REACT_APP_CAMENVPORTAL,
                                                    GAVersion: process.env.REACT_APP_CAMENVPORTAL !== 'production' ? product.versionUat : product.versionProd,
                                                    AppCoreVersion: process.env.REACT_APP_CAMENVPORTAL !== 'production' ? JSON.parse(product.appCoreVersionTest) : JSON.parse(product.appCoreVersionStable)
                                                },
                                            })
                                            : history.push({
                                                pathname: `/fui/order/${product.routeName}`,
                                                state: {
                                                    InstanceType: instanceType,
                                                    CAMPortalEnvironment: process.env.REACT_APP_CAMENVPORTAL,
                                                },
                                            })
                                }
                            /> :
                            <SecondaryButton
                                disabled={true}
                                placeholder="test"
                                label={"Upcoming"}
                                className={classes.viewButton}
                            />
                    }
                </CardActions>
            </Card>
            {openSplunkClusterWarningDialog && (
                <CommonDialog
                    open={openSplunkClusterWarningDialog}
                    onClose={() => setOpenSplunkClusterWarningDialog(false)}
                    title={"WARNING"}
                    dialogType={"servers"}
                    textContent={"If your daily data ingestion is less than 50Gb, go back to Fulfillment Order page and select Dedicated Platform instead of Splunk Cluster Platform. Do you still want to proceed in provisioning Splunk Cluster Platform?"}
                    dialogActions={
                        <DialogActions >
                            <DeclineButton
                                onClick={() => setOpenSplunkClusterWarningDialog(false)}
                                label={"No"}
                                disabled={false}
                            />
                            <AcceptButton
                                onClick={() => handleSplunkClusterWarningSubmit()}
                                label={"Yes"}
                            />
                        </DialogActions>
                    }
                ></CommonDialog>
            )}
            {/*  Genwizard Agent notification for version 4.2.0 that is disabled */}
            {openGADialog && (
                <CommonDialogV2
                    open={openGADialog}
                    onClose={() => setOpenGADialog(false)}
                    title={"Alert"}
                    dialogType={"servers"}
                    textContent={"Genwizard Agent version 4.2.0 is temporary disabled!"}
                    dialogActions={
                        <DialogActions >
                            <AcceptButton2
                                onClick={() => setOpenGADialog(false)}
                                label={"OK"}
                                disabled={false}
                            />
                        </DialogActions>
                    }
                    height={'300px'}
                ></CommonDialogV2>
            )}
        </div>
    );
}

ProductCard.propTypes = {
    /**
     * History property of route library
     */
    history: PropTypes.object,
    /**
     * Redux function to clear the current fulfilement state
     */
    resetFuiState: PropTypes.func,
};

const mapStateToProps = (state) => ({
    belongingTo: state.auth.initiativesBelongTo,
});

export default connect(mapStateToProps, {
    resetFuiState: fuiRedux.resetFuiState,
})(withRouter(ProductCard));
